import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemInformationListingToggleIndexInformationDetailAction } from '../../../shared-models';
import { CellRendererInfoCustomParams } from '../models';

@Component({
  selector: 'grid-ui-cell-renderer-info',
  templateUrl: './cell-renderer-info.component.html',
  styleUrls: ['./cell-renderer-info.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CellRendererInfoComponent implements ICellRendererAngularComp {
  public active = false;
  public hover = false;
  public disabled: any;
  public isRestricted: boolean;
  public isUnsubscribedIndex: boolean;
  private cellValue: CellRendererInfoCustomParams | null = null;

  public refresh(): boolean {
    return false;
  }

  public agInit(params: CellRendererInfoCustomParams): void {
    this.cellValue = params;
    this.isRestricted = params.node.data.restricted;
    this.isUnsubscribedIndex = params.showInfoForUnsubscribed;
  }

  public clickInfoIcon(): void {
    if (!this.cellValue) {
      return;
    }

    const payload = {
      item: this.cellValue as any,
      index: 1,
    };

    this.cellValue.handleAction(new ItemInformationListingToggleIndexInformationDetailAction({ itemPayload: { ...payload } }));
  }
}
